// Durable signup state for the onboarding flow.
//
// The step screens (Plan → Subdomain → Verify-email) normally carry state via react-router
// `location.state`, which is LOST on a hard refresh / Back / direct-URL — stranding the user,
// especially on the paid path (no draft_id => can't resume, re-checkout). We mirror the state into
// sessionStorage so each step can rehydrate, and a fresh signup overwrites it.
//
// SECURITY: never persist the cleartext password (stripped here).
const KEY = "signup_state";

export const saveSignupState = (state) => {
  try {
    const { password, confirmPassword, ...safe } = state || {};
    sessionStorage.setItem(KEY, JSON.stringify(safe));
  } catch (_) { /* sessionStorage unavailable — non-fatal */ }
};

export const loadSignupState = () => {
  try {
    return JSON.parse(sessionStorage.getItem(KEY) || "{}");
  } catch (_) {
    return {};
  }
};

export const clearSignupState = () => {
  try { sessionStorage.removeItem(KEY); } catch (_) { /* non-fatal */ }
};
